import { includes } from 'lodash-es'

import {
  AMBIGUOUS_LOCATION_TYPES,
  BRAND_EXCLUSION_REASONS,
  CATERING,
  DELIVERY,
  GROCERY,
  INACCESSIBLE_URL,
  MISC,
  MULTIPLE_BRANDS_COMBINED,
  NO_MENU,
  NO_WEBSITE,
  NOT_A_RESTAURANT,
} from '../constants'

const isBrandManuallyExcluded = brand => {
  if (
    includes(
      [
        AMBIGUOUS_LOCATION_TYPES,
        BRAND_EXCLUSION_REASONS,
        CATERING,
        DELIVERY,
        GROCERY,
        INACCESSIBLE_URL,
        MISC,
        MULTIPLE_BRANDS_COMBINED,
        NO_MENU,
        NO_WEBSITE,
        NOT_A_RESTAURANT,
      ],
      brand.exclusionReason,
    )
  ) {
    return true
  }

  return false
}

export default isBrandManuallyExcluded
